import React, { useContext, useEffect, useMemo } from "react";
import FormulaGenerator from "../../../FormulaGenerator";
import "./index.scss";
import { getStepInfo } from "../../stepInfo";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const ImplantationSelectTooth = ({
  stepId,
  toggleNextBtnState
}) => {
  const {
    language
  } = useTranslation();
  const {
    dentalData,
    setStepFormula
  } = useContext(StepContext);

  function setData(data) {
    setStepFormula(stepId, data);
    toggleNextBtnState(false);
  } // Disable next btn


  useEffect(() => {
    if (!dentalData || !dentalData.hasOwnProperty("tooth") || !dentalData.tooth.some(tooth => tooth.toothElementsActive.some(el => el === "implantPosition"))) {
      toggleNextBtnState(true);
    } else {
      toggleNextBtnState(false);
    }
  }, [dentalData, toggleNextBtnState]);
  const formulaHelperText = useMemo(() => {
    return getStepInfo(language, stepId)?.formulaHelperText || "";
  }, [language, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "implantationSelectTooth"
  }, /*#__PURE__*/React.createElement(FormulaGenerator, {
    projectData: dentalData,
    setProjectDentalData: setData,
    initialSelection: "implantationSelectTooth",
    availableSwitchers: ["top", "bottom", "base", "implants"],
    formulaHelperText: formulaHelperText
  }));
};

export default ImplantationSelectTooth;